import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Key({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Key</title>
      <path
        d="M15.8889 9.66662C15.8889 9.26854 15.737 8.87045 15.4333 8.56672C15.1295 8.26298 14.7314 8.11111 14.3333 8.11111M14.3333 14.3333C16.9107 14.3333 19 12.244 19 9.66667C19 7.08934 16.9107 5 14.3333 5C11.756 5 9.66667 7.08934 9.66667 9.66667C9.66667 9.87953 9.68092 10.0891 9.70852 10.2944C9.75392 10.632 9.77661 10.8009 9.76133 10.9077C9.74542 11.019 9.72516 11.0789 9.67031 11.177C9.61767 11.2712 9.52489 11.364 9.33933 11.5496L5.36449 15.5244C5.22997 15.6589 5.16271 15.7262 5.11461 15.8047C5.07197 15.8743 5.04054 15.9501 5.02149 16.0295C5 16.119 5 16.2141 5 16.4044V17.7556C5 18.1912 5 18.409 5.08477 18.5753C5.15934 18.7217 5.27833 18.8407 5.42467 18.9152C5.59105 19 5.80885 19 6.24444 19H8.11111V17.4444H9.66667V15.8889H11.2222L12.4504 14.6607C12.636 14.4751 12.7288 14.3823 12.823 14.3297C12.9211 14.2748 12.981 14.2546 13.0923 14.2387C13.1991 14.2234 13.368 14.2461 13.7056 14.2915C13.9109 14.3191 14.1205 14.3333 14.3333 14.3333Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
